import { Outlet } from 'react-router-dom'

/**
 * Layout component for the onboarding flow
 * Contains shared elements like the progress bar
 */
export function OnboardingLayout() {
    return (
        <div className="min-h-screen bg-background font-sans">
            <Outlet />
        </div>
    )
}
